module.exports = __webpack_public_path__ + "img/hongxiaojun.6288f1a4.png";